import { Button, Form } from '..'

import { IconTrashSvg } from '../../assets/icons/svgComponents'
import ClippingIcon from '../../assets/icons/svgComponents/clipping-icon'

import * as S from './styles'

type TestCardProps = {
  onRemove: any
  data: any
  disable: boolean
  handleImportClick: () => void
}

const TestCardPersonality = ({
  onRemove,
  data,
  disable,
  handleImportClick
}: TestCardProps) => {
  return (
    <S.Wrapper>
      <S.CardHeader>
        <p>Personalidade</p>
        <button onClick={onRemove}>
          <IconTrashSvg />
        </button>
      </S.CardHeader>
      <S.CardBody>
        <Form data={data} />
        <div className="import-files">
          Anexar arquivos
          <Button disabled={disable} onClick={() => handleImportClick()}>
            <ClippingIcon />
          </Button>
        </div>
      </S.CardBody>
    </S.Wrapper>
  )
}

export default TestCardPersonality
